import DeliveryAndPayment from "./delivery-and-payment";

export default DeliveryAndPayment;